<template>
  <div
    class="mfaq-home"
    :class="{'is-arabic': $i18n.locale == 'ar'}"
  >
    <div class="heador">
      <common-header
        :language-list="allOptions.languageList"
        :language="allOptions.language"
        :app-list="allOptions.appList"
        :platform-list="allOptions.platformList"
        :game-id-key="allOptions.gameIdKey"
        :platform="allOptions.platform"
        :title="allOptions.title"
        :contact-us-game-list="allOptions.contactUsGameList"
        :app-name="allOptions.appName"
        :game-id="allOptions.gameId"
        @change-param="search"
        @on-height="onHeight"
        ref="refCommonHeader"
      ></common-header>
      <div class="line"></div>
    </div>
    <div
      class="main"
      ref="refMain"
    >
      <search-result
        ref="refSearch"
        v-show="q"
      ></search-result>
      <a-spin
        tip="Loading..."
        :spinning="loadings.loading"
      >
        <router-view
          v-show="!q"
          @init-options="initOptions"
          :loadings="loadings"
        ></router-view>
      </a-spin>
    </div>
  </div>
</template>
<script>
export default {
  name: "mfaqHome",
  components: {
    commonHeader: () => import("./commonHeader"),
    searchResult: () => import("./searchResult")
  },
  provide() {
    return {
      vm: this
    };
  },
  data() {
    return {
      allOptions: {
        platform: undefined,
        title: "",
        languageList: [],
        language: undefined,
        appList: [],
        platformList: [],
        gameIdKey: "",
        key: "",
        contactUsGameList: []
      },
      q: "", //搜索关键词
      loadings: {
        loading: false
      }
    };
  },
  mounted() {
    this.$bus.$on("clear-search", this.seeDetail);
    let params = this.$route.params;
    let { page = '', gameIdKey } = params;
    page = page.toLowerCase();
    if (page == "account") {
      this.$bus.pageInfo.accountIdKey = gameIdKey;
    }
  },
  methods: {
    seeDetail() {
      this.q = "";
    },
    // 语言变化
    handleLanguageChange(val) {},
    handleFilterChange() {},
    search(q) {
      this.q = q;
      console.log("refsearch", this.$refs.refSearch);
      this.$refs.refSearch.search(q);
    },
    initOptions(val) {
//      console.log("init-params", val);
      this.allOptions = val;
    },
    onHeight(val) {
      // this.$refs.refMain.style.marginTop = val + "px";
      this.$refs.refMain.style.paddingTop = val + "px";
    }
  },
  beforeDestroy() {
    this.$bus.$off("clear-search");
  }
};
</script>
<style lang="scss">
@import "~@/style/media.scss";
.mfaq-home {
  &.is-arabic {
    // .ai-card {
    unicode-bidi: isolate;
    direction: rtl;
    // }
    // .ai-card .ant-spin-container > {
    //   .title,
    //   .ul-list,
    //   .see-more {
    //     unicode-bidi: isolate;
    //     direction: rtl;
    //   }
    //   .ai-card {
    //     unicode-bidi: isolate;
    //     direction: rtl;
    //   }
    // }
  }
  .heador {
    background: #0E131F;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
  }
  .main {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0px 30px 20px;
    // margin-top: 172px;
    .card-wrap {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      // card 为2, 5, 8... 时 处理布局
      @include media-min-md {
        &.need-one {
          &:after {
            content: "";
            width: 26%;
            height: 150px;
          }
        }
      }
    }
  }
  @include media-max-lg {
    .main {
      padding-top: 100px !important;
    }
  }
}
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-track {
  background: #eee;
}
::-webkit-scrollbar-thumb {
  background: #ccc;
}
</style>